module.exports = __webpack_public_path__ + "static/img/badge-multi-active-irregular.8410248.svg";